import {set as setCookie, remove as removeCookie } from 'es-cookie';

import { authenticationConstants, alertConstants } from "../_constants";
import { clientWithoutCredentials, clientWithCredentials } from "../_helpers";
import { push } from 'react-router-redux';

export const authenticationAction = {
    login,
    logout,
    refresh
}

function login(credentials:any) {
    return function (dispatch:any) {
        clientWithoutCredentials.post("api/auth/login", JSON.stringify(credentials))
            .then(data => {
                setCookie("token", data.data.token, { path: '/', expires: 60*60*24*30 });
                dispatch({
                    type: authenticationConstants.AUTHENTICATION_SUCCESSFUL,
                    user: data.data
                });
                dispatch({
                    type: alertConstants.ALERT_SHOW,
                    notification: {message: "login_success",
                                    level: "notification" }
                });
                dispatch(push("/"));
            })
            .catch(error => {
                dispatch({
                    type: alertConstants.ALERT_SHOW,
                    notification: {
                        message: error.message,
                        level: "error"
                    }
                })
                console.error(error);
            });
    }
}

function logout() {
    return function (dispatch:any) {
        removeCookie("token");
        dispatch({
            type: authenticationConstants.AUTHENTICATION_LOGOUT
        });
        dispatch(push("/login"));
        localStorage.removeItem("user");
        dispatch({
            type: alertConstants.ALERT_SHOW,
            notification: {message: "user_logout",
                            level: "notification" }
        });
    }
}

function refresh() {
    return function(dispatch:any) {
        clientWithCredentials(dispatch).get("api/user/yourself")
            .then(data => {
                dispatch({
                    type: "logout",
                    user: data.data
                });
                console.log(data.data);
                localStorage.setItem("user", JSON.stringify(data.data));
            })
            .catch(error => {
                removeCookie("token");
                dispatch(push("/login"));
            });;
    }
}